module.exports = __webpack_public_path__ + "media/images/sites/health/bg-footer-2a74a7db74b778dbfa5a491b69cad6a2.jpg";